var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHideEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.81 84.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.95,7.45l12.76,12.27c-6.94,5.6-12.46,11.8-15.88,16.05-2.44,3.03-2.44,7.32,0,10.35,7.72,9.6,26.12,29.19,47.58,29.19,7.22,0,14.09-2.22,20.33-5.53l15.29,14.71,7.16-7.45L12.11,0l-7.16,7.45Zm44.24,57.84c-11.9,0-21.54-9.89-21.54-22.09,0-4.05,1.08-7.83,2.93-11.1l30.6,29.44c-3.43,2.36-7.56,3.75-12,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.98,35.76c-7.72-9.6-26.12-29.19-47.58-29.19-6.71,0-13.12,1.92-19,4.84l11.34,11.05c2.32-.88,4.83-1.36,7.45-1.36,11.9,0,21.54,9.89,21.54,22.09,0,2.29-.34,4.5-.97,6.58l12.09,11.78c6.59-5.44,11.84-11.35,15.14-15.45,2.44-3.03,2.44-7.32,0-10.35Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEyeIcon);
export default __webpack_public_path__ + "static/media/HideEyeIcon.d8969f1a1a5796ad9dbd47f8c5924c60.svg";
export { ForwardRef as ReactComponent };